import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=95e8da96&"
import script from "./ui-icon.vue?vue&type=script&lang=js&"
export * from "./ui-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e8da96')) {
      api.createRecord('95e8da96', component.options)
    } else {
      api.reload('95e8da96', component.options)
    }
    module.hot.accept("./ui-icon.vue?vue&type=template&id=95e8da96&", function () {
      api.rerender('95e8da96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-icon/ui-icon.vue"
export default component.exports